import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'
import { TranslateServiceService } from '../services/translate-service.service';
import { LoginService } from '../services/login.service';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit {

  logoRace: string;
  goalBarBg: string;
  donorPastInput: any;

  // Form Validations
  loginForm: FormGroup;

  constructor(
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    let _ = this;
    _.getRaceConfig();
    _.checkoutValidationForm();
  }

  checkoutValidationForm(){
    let _ = this;
    _.loginForm = new FormGroup({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');

    return raceName[4];
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getRaceConfig(){
    let _ = this;
    let conditions = {
     "conditions":{
       "race_url": _.getRaceName(),
       "active": true,
     },
     "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      document.title = data['results'][0].name;
      _.logoRace = data['results'][0].design.images.logo_header;
      _.goalBarBg = data['results'][0].design.color.secundary;
    })
  }

  upLabel(labelName, inputName){
    let _ = this;
    let labelTopUp = document.querySelector('.' + labelName);
    let allUpLabels = document.getElementsByClassName('label-up-active');
    let inputToFocus = document.querySelector('.' + inputName);

    (<HTMLInputElement>inputToFocus).focus();
    labelTopUp.classList.add('label-up-active');
    _.donorPastInput = inputToFocus;
  }

  downLabel(labelName, inputName){
    let placeholderElement = document.querySelector('.' + labelName);
    let inputPlaceholderElement = (<HTMLInputElement>document.querySelector('.' + inputName));

    if(inputPlaceholderElement.value == ''){
      placeholderElement.classList.remove('label-up-active');
    }
  }

  createLogin(){
    let _ = this;
    let loginConditions = {
    	"user":{
    		"email": _.loginForm.controls.email.value,
    		"password": _.loginForm.controls.password.value
    	},
    	"merchant": _.getMerchant()
    }
    _.apiService.createLogin(loginConditions).subscribe(data => {
      console.log(data);
      localStorage.setItem('tokenL', data['token']);
      localStorage.setItem('avatarC', data['user_id'].avatar);
      localStorage.setItem('emailC', data['user_id'].email);
      localStorage.setItem('userIdC', data['user_id'].user_id);
      localStorage.setItem('teamC', data['user_id'].team_url);
      localStorage.setItem('userUrlC', data['user_id'].collector_url);
      localStorage.setItem('userFullNameC', data['user_id'].full_name);
      location.href = "/" + _.getMerchant() + "/" + _.getRaceName();
    })
  }

  closeModal(){
    let _ = this;
    _.loginService.isOpen = false;
  }
}
